import { render, staticRenderFns } from "./PhotoValidation.vue?vue&type=template&id=293c7a00&"
import script from "./PhotoValidation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PhotoValidation.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports